export const PRICING_ANALYTICS_QUERY_KEY = ["pricing-analytics"];

export const PRICING_ANALYTICS_FACETS_QUERY_KEY = ["pricing-analytics-facets"];
